export async function timeout (ms: number): Promise<void> {
  return await new Promise(resolve => setTimeout(resolve, ms))
}

export function dateFromISO (stringISO: string): string {
  return stringISO.split('T')[0]
}

export function timeFromISO (stringISO: string): string {
  const date = new Date(stringISO)
  const hh = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')
  const timeString = hh + ':' + mm
  return timeString
}
